import { Antwort, AusschreibungStatus, ExperteAntwort, type VivaStatus, vivaStatus } from '../dtos';

// Use an object instead of an array so TypeScript satisfies that all VivaStatus values are covered.
const vivaStatusOrder = {
  [vivaStatus.IN_PLANUNG]: 0,
  [vivaStatus.IM_AUSSCHREIBUNGSPORTAL]: 1,
  [vivaStatus.ABGESCHLOSSEN]: 2,
  [vivaStatus.FREIGEGEBEN]: 3,
} satisfies Record<VivaStatus, number>;

export function sortVivaStatus(a: VivaStatus, b: VivaStatus): number {
  return vivaStatusOrder[a] - vivaStatusOrder[b];
}

export function sortByVivaStatus(a: { status: VivaStatus }, b: { status: VivaStatus }): number {
  return sortVivaStatus(a.status, b.status);
}

const ausschreibungStatusOrder: Record<AusschreibungStatus, number> = {
  keineAusschreibung: -1,
  vertragStorniert: 0,
  ausschreibungAbgebrochen: 1,
  ausschreibungsentwurfGeloescht: 2,
  ausschreibungVeroeffentlicht: 3,
  ausschreibungBeendet: 4,
  angebotsentwurfGeloescht: 5,
  angebotVeroeffentlicht: 6,
  angebotBeendet: 7,
};

export function sortAusschreibungStatus(a: AusschreibungStatus, b: AusschreibungStatus): number {
  return ausschreibungStatusOrder[a] - ausschreibungStatusOrder[b];
}

const experteAntwortOrder: Record<Antwort, number> = {
  keineAntwort: -1,
  ausschreibungAbgelehnt: 0,
  ausschreibungAbgelaufen: 1,
  ausschreibungUnterVorbehaltAngenommen: 2,
  ausschreibungAngenommen: 3,
  angebotAbgelehnt: 4,
  angebotAbgelaufen: 5,
  angebotAngenommen: 6,
};

export function sortExperteAntwort(a: Pick<ExperteAntwort, 'antwort'>, b: Pick<ExperteAntwort, 'antwort'>): number {
  return experteAntwortOrder[a.antwort] - experteAntwortOrder[b.antwort];
}
